import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/Layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login')
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
      path: '/redirect',
      component: Layout,
      hidden: true,
      children: [
          {
              path: '/redirect/:path*',
              component: () => import('@/views/redirect/index')
          }
      ]
  },
  {
    path: '/home',
    component: () => import('@/views/layout/Layout'),
    hidden: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
